@layer reset, default, disabled, error, focus;

@layer reset {
  :host {
    display: block;

    .gcds-textarea-wrapper {
      margin: 0;
      padding: 0;
      border: 0;

      textarea {
        box-sizing: border-box;
      }
    }
  }
}

@layer default {
  :host .gcds-textarea-wrapper {
    width: 100%;
    max-width: 75ch;
    font: var(--gcds-textarea-font-desktop);
    color: var(--gcds-textarea-default-text);
    transition: color ease-in-out 0.15s;

    @media only screen and (width < 48em) {
      font: var(--gcds-textarea-font-mobile);
    }

    textarea {
      display: block;
      min-width: 50%;
      width: 100%;
      max-width: 100%;
      height: auto;
      min-height: var(--gcds-textarea-min-height);
      font: inherit;
      margin: var(--gcds-textarea-margin) !important;
      padding: var(--gcds-textarea-padding) !important;
      background-color: var(--gcds-textarea-default-background);
      background-image: none;
      color: var(--gcds-textarea-default-text);
      border: var(--gcds-textarea-border-width) solid currentColor;
      border-radius: var(--gcds-textarea-border-radius);
      transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s,
        outline ease-in-out 0.15s;
    }
  }
}

@layer disabled {
  :host .gcds-textarea-wrapper.gcds-disabled {
    color: var(--gcds-textarea-disabled-text);

    gcds-label {
      --gcds-label-text: currentColor;
    }

    gcds-hint {
      --gcds-hint-text: currentColor;
    }

    textarea:disabled {
      cursor: not-allowed;
      background-color: var(--gcds-textarea-disabled-background);
      border-color: var(--gcds-textarea-disabled-text);
    }
  }
}

@layer error {
  :host .gcds-textarea-wrapper {
    .error-message-container {
      display: block;
    }

    textarea.gcds-error:not(:focus) {
      border-color: var(--gcds-textarea-danger-border);
    }
  }
}

@layer focus {
  :host .gcds-textarea-wrapper:focus-within textarea:focus {
    border-color: var(--gcds-textarea-focus-border);
    outline: var(--gcds-textarea-outline-width) solid
      var(--gcds-textarea-focus-border);
    outline-offset: var(--gcds-textarea-border-width);
    box-shadow: var(--gcds-textarea-focus-box-shadow);
  }
}
